import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';

@Injectable({
	providedIn: 'root'
})
export class NotFoundGuard implements CanActivate {
	private authorize = inject(AuthorizeService);
	private router = inject(Router);
	private route = inject(ActivatedRoute);


	canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.authorize.authState$.pipe(
			filter(s => s !== 'unknown'),
			take(1),
			map(s => {
				if (s === 'authenticated') {
					this.router.navigate(['/admin/dashboard'], {
						relativeTo: this.route
					});
				}
				else {
					this.router.navigate(['/account/login'], {
						relativeTo: this.route
					});
				}
				return false;
			})
		);
	}
}
